import * as React from "react";
import { useState } from "react";
import { Button } from "components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "components/ui/dropdown-menu";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "components/ui/dialog";

const ActionsCell = ({ rowData }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="flex">
            <Button variant="ghost" className="flex h-8 w-8 p-0 justify-end">
              <span className="sr-only">Open menu</span>
              {/* Replace with your icon */}
            </Button>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuItem onClick={() => setOpen(true)}>Edit</DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem>View customer</DropdownMenuItem>
          <DropdownMenuItem>View payment details</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Edit Store</DialogTitle>
            <DialogDescription>
              Edit details for <b>{rowData.address}</b>
            </DialogDescription>
          </DialogHeader>
          <div style={{ display: 'flex', gap: '8px', marginTop: '16px', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Button
              variant="destructive"
              style={{ marginRight: 'auto' }}
              onClick={() => {
                if (window.confirm('Are you sure you want to delete this store?')) {
                  //  Call your delete handler here
                }
              }}
            >
              Delete
            </Button>
            <Button onClick={() => setOpen(false)}>Close</Button>
            <Button variant="outline" onClick={() => setOpen(false)}>Save</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ActionsCell;